var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Trips-formControlInput-MezoI {\r\n    width: 340px;\r\n    max-width: 100%;\r\n    height: 48px;\r\n    border: 1px solid var(--search-input-border);\r\n    border: 1px solid var(--search-input-border);\r\n    border-radius: 6px;\r\n}\r\n\r\n.Trips-locationBgIcon-2VrnW {\r\n    background-repeat: no-repeat;\r\n    background-position: 18px 50%;\r\n    padding-left: 40px;\r\n    padding-right: 18px;\r\n    background-size: 13px;\r\n    background-image: url(" + escape(require("../../../public/SiteIcons/searchIcon.svg")) + ");\r\n}", ""]);

// exports
exports.locals = {
	"formControlInput": "Trips-formControlInput-MezoI",
	"locationBgIcon": "Trips-locationBgIcon-2VrnW"
};